import styled from 'styled-components';
import { SliderTrackMixin } from '../../mixins/components/SliderMixin';

/**
 * @since 6.12.0
 */
var SliderTrack = /*#__PURE__*/styled.div.withConfig({
  displayName: "SliderTrack",
  componentId: "c11n-8-107-0__sc-jhfpap-0"
})(["", ""], SliderTrackMixin);
SliderTrack.displayName = 'SliderTrack';

/** @component */
export { SliderTrack };